import React, { useEffect } from "react";
import "@/App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useParams,
  useLocation,
} from "react-router-dom";
import { I18nProvider, useI18n } from "@/i18n/I18nContext";
import Layout from "@/components/Layout";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import Terms from "@/pages/Terms";
import ThankYou from "@/pages/ThankYou";

const SUPPORTED_LANGS = ["mx", "en"];

const TitleUpdater = () => {
  const { t, lang } = useI18n();
  useEffect(() => {
    document.title = t("meta.title");
    document.documentElement.setAttribute("lang", lang === "mx" ? "es-MX" : "en");
    let desc = document.querySelector('meta[name="description"]');
    if (!desc) {
      desc = document.createElement("meta");
      desc.setAttribute("name", "description");
      document.head.appendChild(desc);
    }
    desc.setAttribute("content", t("meta.description"));
  }, [t, lang]);
  return null;
};

const LangRoute = () => {
  const { lang } = useParams();
  const location = useLocation();
  if (!SUPPORTED_LANGS.includes(lang)) {
    return <Navigate to="/mx" replace />;
  }
  return (
    <I18nProvider lang={lang}>
      <TitleUpdater />
      <Layout />
    </I18nProvider>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Navigate to="/mx" replace />} />
          <Route path="/thank_you" element={<ThankYou />} />
          <Route path="/:lang" element={<LangRoute />}>
            <Route index element={<Home />} />
            <Route path="privacy" element={<PrivacyPolicy />} />
            <Route path="cookies" element={<CookiePolicy />} />
            <Route path="terms" element={<Terms />} />
          </Route>
          <Route path="*" element={<Navigate to="/mx" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
